import { cloneElement, useEffect, useRef } from 'react'
import { buildIdFromText } from '@/utils'

import styles from './SectionContainer.module.scss'
import classNames from 'classnames'
import useStore from '@/store'

const SectionContainer = ({ _type, children, cmsTitle, sectionsLength, nextSectionType, isDark }) => {
  const containerRef = useRef(null)
  const id = buildIdFromText(cmsTitle)
  const setTheme = useStore(state => state.setTheme)
  const newElement = cloneElement(children, {
    sectionId: id,
  })

  useEffect(() => {
    setTheme(isDark ? 'dark' : 'light')
  }, [isDark, setTheme])

  return (
    <section
      id={id}
      ref={containerRef}
      data-component={_type}
      className={classNames(styles.SectionContainer)}
      data-sections-length={sectionsLength}
      data-next-section-type={nextSectionType}
      data-section-theme={isDark ? 'dark' : 'light'}
    >
      {newElement}
    </section>
  )
}

SectionContainer.displayName = 'SectionContainer'

export default SectionContainer
